export default __webpack_public_path__ + "static/media/purp_chat.1de095f3.svg";